<template>
  <div class="snippet-details details">
    <div class="close" v-on:click="close()"><b-icon icon="close" size="is-large" /></div>
    <b-field label="Full name">
      <b-input maxlength="128" minlength="3" type="text" v-model="fullName"></b-input>
    </b-field>
    <b-field label="Sort name">
      <b-input maxlength="64" minlength="3" type="text" v-model="sortName"></b-input>
    </b-field>
    <b-field label="Active" class="active-group">
      <b-switch v-model="active">{{active|yesNo}}</b-switch>
      <b-button v-if="mayDelete" @click="deleteCollege" icon-left="delete" rounded>Delete</b-button>
    </b-field>
    <b-button type="is-success" @click="save" class="save" rounded>Save</b-button>
    <p v-if="saveMessage.length > 2" class="message">{{saveMessage}}</p>
  </div>
</template>

<script>
import filters from "../mixins/filters";
import { saveCollege, addCollege } from "../api/methods";

export default {
  name: 'CollegeDetail',
  props: {
     college: {
       type: Object,
       default() {
         return {
          _id: '',
          fullName: '',
          sortName: '',
          active: false
        };
       }
     }
  },
  mixins: [filters],
  mounted() {
    if (this.college instanceof Object) {
      if (this.college.fullName) {
        this.fullName = this.college.fullName;
      }
      if (this.college.sortName) {
        this.sortName = this.college.sortName;
      }
      if (this.college.active) {
        this.active = this.college.active;
      }
    }
  },
  created() {
    
  },
  data() {
    return {
      fullName: '',
      sortName: '',
      active: false,
      saveMessage: ''
    }
  },
  computed: {
    mayDelete() {
      return this.active === false;
    },
  },
  methods: {
    close() {
      this.$parent.close();
    },
    save() {
      const { _id } = this.college;
      const isNew = _id.length < 6;
      const data = {
        fullName: this.fullName.trim(),
        sortName: this.sortName.trim(),
        active: this.active
      }
      let valid = true;
      if (data.fullName.length < 3) {
        valid = false;
      }
      if (data.sortName.length < 3) {
        valid = false;
      }

      if (valid) {
        if (isNew) {
          addCollege(data).then(this.update);
        } else {
          saveCollege(_id,data).then(this.update);
        }
      }
    },
    deleteCollege() {

    },
    update(data) {
      if (data._id) {
        this.saveMessage = this.college._id.length > 5? "College updated" : "New college added";
        setTimeout(() => {
          this.$parent.update();
        }, 500);
        setTimeout(() => {
          this.close();
        }, 1500)
      }
    },
  },
}
</script>